<script>
import { Doughnut, mixins } from "vue-chartjs";
export default {
  extends: Doughnut,
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    datasets: {
      type: Object,
      default: () => [],
    },
    width: { type: String },
    height: { type: String },
  },
  data() {
    return {
      options: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    this.renderChart(this.datasets, this.options)
    let textInTheMiddle = ''
    const { attendant_percent } = this.datasets;
    textInTheMiddle = attendant_percent ? `${attendant_percent}%` : '';
    this.textCenterPercentage(textInTheMiddle);
    this.textCenterLabel('PRESENTE')
  },
  
  methods: {
    textCenterPercentage(val) {
  Chart.pluginService.register({
    beforeDraw: function (chart) {
      const width = chart.chart.width;
      const height = chart.chart.height;
      const ctx = chart.chart.ctx;

      const fontSize = (height / 90).toFixed(2);
      ctx.font = fontSize + "em sans-serif";
      ctx.textBaseline = "middle";

      const text = val;
      const textWidth = ctx.measureText(text).width;
      const textX = Math.round((width - textWidth) / 2);
      const textY = height / 2;

      const clearX = 0;
      const clearY = 0;
      const clearWidth = width;
      const clearHeight = height;

      ctx.clearRect(clearX, clearY, clearWidth, clearHeight);

      ctx.fillStyle = '#54CAA6';
      ctx.fillText(text, textX, textY - 5);
    }
  });
},

    textCenterLabel(val) {
      Chart.pluginService.register({
        beforeDraw: function (chart) {
          const width = chart.chart.width;
          const height = chart.chart.height;
          const ctx = chart.chart.ctx;
          ctx.restore();
          const fontSize = (height / 250).toFixed(2);
          ctx.font = fontSize + "em sans-serif";
          ctx.textBaseline = "middle";
          const text = val;
          const textX = Math.round((width - ctx.measureText(text).width) / 2);
          const textY = height / 2;

          ctx.fillText(text, textX, textY+15);
          ctx.save();
        }
      });
      Chart.plugins.unregister(this.chartdata);
    }

  }
}
</script>

<style lang="css"></style>
